<template>
  <v-app>
    <v-overlay z-index="9999" :value="storeLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div id="temphtml" style="display: none"></div>
    <v-main v-if="multiselect">
      <router-view></router-view>
    </v-main>
    <div v-else-if="!storeExpire">
      <router-view v-if="isRegPage"></router-view>
      <router-view v-else-if="isRegterms"></router-view>
      <Login v-else-if="!storeLogged && !TokenProvide" @logged="countdown" />
      <v-main v-else>
        <Toolbar :webform="false" />
        <v-divider></v-divider>
        <router-view></router-view>
      </v-main>
    </div>
    <div v-else>
      <router-view v-if="isRegPage"></router-view>
      <router-view v-else-if="isRegterms"></router-view>
      <Login
        v-else
        :timeoutMsg="timeoutMsg"
        :timeout="timeout"
        :logged="storeLogged"
        @logged="countdown"
      />
    </div>
    <div class="pa-0 ma-0">
      <v-footer padless app v-if="SurveyLength">
        <v-col class="text-center py-1" cols="12" style="font-size: 12px">
          SurveyMe version 1.1.05 &copy;{{ new Date().getFullYear() }} —
          <strong>Chat Me Co.,Ltd.</strong>
        </v-col>
      </v-footer>
      <v-footer
        v-else
        :style="`${
          this.$route.name === 'formconfig'
            ? ` clear: both;
                  z-index: 99;
                  position: fixed;
                  left: 0;
                  bottom: 0;
                  width: 100%;`
            : `clear: both; position: relative; z-index: 99;`
        }`"
        padless
      >
        <v-col class="text-center py-1" cols="12" style="font-size: 12px">
          SurveyMe version 1.1.05 &copy;{{ new Date().getFullYear() }} —
          <strong>Chat Me Co.,Ltd.</strong>
        </v-col>
      </v-footer>
    </div>
  </v-app>
</template>

<script>
import Swal from "sweetalert2";
import Toolbar from "./components/StructureUI/Toolbar";
import Login from "./views/auth/Login";
export default {
  components: { Toolbar, Login },
  name: "App",
  data() {
    return {
      trial: false,
      allow_trial: false,
      multiselect: false,
      timeout: 0,
      timeoutMsg: "session ของคุณหมดอายุ\nกรุณาเข้าใช้งานใหม่อีกครั้ง",
    };
  },
  mounted() {
    // this.countdown();
    document.getElementById("app").addEventListener("click", this.clear);
  },
  watch: {
    $route(newValue, oldValue) {
      if (this.$store.state.editing) {
        this.$store.commit("ToggleEditing");
      }
      if (oldValue && newValue) {
        document.getElementsByTagName("html")[0].style.overflow =
          newValue.name === "formconfig" ? "hidden" : "";
        if (newValue.name === "formconfig") {
          window.scrollTo(0, 0);
        }
      }
    },
  },
  created() {
    if (this.$route.name === "multiselect") {
      this.multiselect = true;
    } else if (this.$route.name === "webform") {
      this.multiselect = true;
    } else if (this.$route.name === "endwebform") {
      this.multiselect = true;
    } else if (this.$route.name === "startform") {
      this.multiselect = true;
    } else if (this.$route.name === "oneid_validate") {
      this.multiselect = true;
    } else {
      if (this.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token")) {
        if (this.$route.params.surveyID !== undefined) {
          this.$store.dispatch("getQuestionLabel", this.$route.params);
          this.$store.dispatch("getSurveyByID", this.$route.params.surveyID);
          this.$store.dispatch(
            "getQuestionPermission",
            this.$route.params.surveyID
          );
        }
        this.$store.commit(
          "Login",
          this.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token")
        );
        document.getElementsByTagName("html")[0].style.overflow =
          this.$route.name === "formconfig" ? "hidden" : "";
        if (this.$route.name === "formconfig") {
          window.scrollTo(0, 0);
        }
        this.countdown();
      } else {
        if (!this.multiselect) {
          if (this.$route.path !== "/" && this.$route.path !== "/terms") {
            this.$router.push({ path: "/" });
          }
        }
      }
      if (
        !this.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_username")
      ) {
        if (this.$cookies.get(process.env.VUE_APP_COOKIE + "_username")) {
          this.$cookies.set(
            process.env.VUE_APP_CM_AUTH_COOKIE + "_username",
            this.$cookies.get(process.env.VUE_APP_COOKIE + "_username"),
            "7d"
          );
        }
      }
    }
  },
  computed: {
    isRegPage() {
      return this.$route.name === "register";
    },
    isRegterms() {
      return this.$route.name === "terms";
    },
    storeLoading() {
      return this.storeLogged ? this.$store.state.loading : false;
    },
    TokenProvide() {
      return this.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token");
    },
    storeLogged() {
      return this.$store.state.logged;
    },
    storeExpire() {
      return this.$store.state.expire;
    },
    SurveyLength() {
      // let surveylist = this.$store.state.surveylist;
      // let rolelist = this.$store.state.rolelist;
      return (
        this.$route.name === "survey" ||
        this.$route.name === "overview" ||
        this.$route.name === "role" ||
        this.$route.name === "permission" ||
        this.$route.name === "questionsummary" ||
        this.$route.name === "question"
      );
    },
  },
  methods: {
    countdown() {
      let vm = this;
      this.$store.state.interval = setInterval(() => {
        if (vm.timeout === 3600) {
          vm.$store.commit("Logout");
          vm.destory();
        }
        if (
          vm.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token") &&
          vm.$store.state.token
        ) {
          if (
            vm.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token") !==
            vm.$store.state.token
          ) {
            vm.$store.state.token = null;
            Swal.fire({
              icon: "warning",
              text: "พบการ login มากกว่า 1 user",
              title: "",
              confirmButtonText: "ตกลง",
            }).then(() => {
              window.location.reload();
            });
          }
        }
        if (
          !vm.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token") &&
          vm.$store.state.logged
        ) {
          if (vm.timeout !== 3600 && vm.$store.state.logged) {
            Swal.fire({
              html: `พบการ logout`,
              icon: "warning",
              showCancelButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "ตกลง",
            });
          }
          vm.$store.commit("Logout");
          vm.destory();
        }
        // console.log(vm.timeout);
        vm.timeout += 1;
      }, 1000);
    },
    clear() {
      this.timeout = 0;
    },
    destory() {
      clearInterval(this.$store.state.interval);
    },
  },
};
</script>
<style>
.swal2-container {
  z-index: 20000 !important;
}
</style>
